import authorization from 'live/services/authorization'

import { api, assetUrl } from './api.config'
import { IQueryParamsAssetTypeList } from '../../types/IQueryParamsList'
import { defaultParamsForResourceType } from '../../utils/constants'

export interface IPaginatedList<T> {
    page: number
    perPage: number
    total: number
    data: T[]
}

export type AssetType = {
    id: string
    name: string
}

export const getAssetType = async (assetTypeId: string): Promise<AssetType> => {
    return fetch(`${assetUrl}${api.assetType.assetTypes}/${assetTypeId}/`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }
        if (data.ok) {
            return jsonData
        } else {
            throw new Error(`{"status": ${data.status} , "message": "${data.statusText}"}`)
        }
    })
    // .then(fetchData => {
    //     if (fetchData.ok) {
    //         return fetchData.json()
    //     } else if (fetchData.status === 404) {
    //         return undefined
    //     } else {
    //         throw new Error(`{"status": ${fetchData.status} , "message": "${fetchData.statusText}"}`)
    //     }
    // })
    // .catch(() => {
    //     throw new Error()
    // })
}

export const getAssetTypes = async (params: IQueryParamsAssetTypeList): Promise<AssetType[]> => {
    const queryString = new URLSearchParams({
        limit: params?.perPage?.toString() ?? '',
        offset: (Math.max(1, params?.page ?? 0) - 1)?.toString() ?? '0',
        keyword: params?.keyword?.toString() ?? '',
        orderBy: params?.orderBy?.toString() ?? 'id',
        direction: params?.direction?.toString() ?? 'ASC'
    }).toString()

    return fetch(`${assetUrl}${api.assetType.assetTypes}?${queryString}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(async fetchData => {
            if (fetchData.ok) {
                const data = await fetchData.json()

                return data
            } else {
                throw new Error(`{"status": ${fetchData.status} , "message": "${fetchData.statusText}"}`)
            }
        })
        .catch(err => {
            return JSON.parse(err.message)
        })
}

export const getAssetTypesToResourceGroup = async (params: IQueryParamsAssetTypeList): Promise<AssetType[]> => {
    const qs = new URLSearchParams({
        limit: params?.perPage?.toString() ?? '',
        offset: (Math.max(1, params?.page ?? 0) - 1)?.toString() ?? '0',
        keyword: params?.keyword?.toString() ?? '',
        orderBy: params?.orderBy?.toString() ?? 'id',
        direction: params?.direction?.toString() ?? 'ASC'
    }).toString()

    return fetch(`${assetUrl}${api.assetType.assetTypes}/types-to-group?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(async fetchData => {
            let jsonData

            try {
                jsonData = await fetchData.json()
            } catch (err) {
                jsonData = undefined
            }

            if (fetchData.ok) {

                return jsonData
            } else {
                throw new Error(`{"status": ${fetchData.status} , "message": "${fetchData.statusText}"}`)
            }
        })
        .catch(err => {
            return JSON.parse(err.message)
        })
}

export const getAssetTypesToResourceGroupAsList = async (
    params: IQueryParamsAssetTypeList
): Promise<IPaginatedList<AssetType>> => {
    const qs = new URLSearchParams({
        limit: params?.perPage?.toString() ?? '',
        offset: (Math.max(1, params?.page ?? 0) - 1)?.toString() ?? '0',
        keyword: params?.keyword?.toString() ?? '',
        orderBy: params?.orderBy?.toString() ?? 'id',
        direction: params?.direction?.toString() ?? 'ASC'
    }).toString()

    return fetch(`${assetUrl}${api.assetType.assetTypes}/types-to-group-list?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(async fetchData => {
            let jsonData

            try {
                jsonData = await fetchData.json()
            } catch (err) {
                jsonData = undefined
            }

            if (fetchData.ok) {

                return jsonData
            } else {
                throw new Error(`{"status": ${fetchData.status} , "message": "${fetchData.statusText}"}`)
            }
        })
        .catch(err => {
            return JSON.parse(err.message)
        })
}

export const getAssetTypesAsMap = async (): Promise<Map<string, AssetType>> => {
    return getAssetTypes(defaultParamsForResourceType).then(types =>
        types.reduce((map, type) => map.set(type.id, type), new Map<string, AssetType>())
    )
}

export const updateAssetType = async (body: AssetType): Promise<AssetType> => {
    const data = await fetch(`${assetUrl}${api.assetType.assetTypes}/`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })

    return data
}

// export const deleteAssetType = async (assetTypeId: string): Promise<AssetType> => {
//     return fetch(`${assetUrl}${api.assetType.assetTypes}/${assetTypeId}/`, {
//         method: 'DELETE',
//         credentials: 'same-origin',
//         headers: {
//             'Content-Type': 'application/json'
//         }
//     })
//         .then(fetchData => {
//             if (fetchData.ok) {
//                 return fetchData.json()
//             } else if (fetchData.status === 404) {
//                 return undefined
//             } else {
//                 throw new Error(`{"status": ${fetchData.status} , "message": "${fetchData.statusText}"}`)
//             }
//         })
//         .catch(() => {
//             throw new Error()
//         })
// }

export const deleteAssetType = async (body: string): Promise<void> => {
    const data = await fetch(`${assetUrl}${api.assetType.assetTypes}/${body}/`, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const createAssetType = async (body: AssetType): Promise<AssetType> => {
    const data = await fetch(`${assetUrl}${api.assetType.assetTypes}/`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })

    return data
}
